module.exports = __webpack_public_path__ + "static/media/strawberry-thumb.01ce0ba8.jpg";